import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "./Background.css";

const Background = () => {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 1000], [0, -150]);
  const y2 = useTransform(scrollY, [0, 1000], [0, -80]);
  const y3 = useTransform(scrollY, [0, 1000], [0, -200]);

  return (
    <div className="bg-wrapper" aria-hidden="true">
      {/* Animated gradient background */}
      <div className="bg-gradient-animated" />

      {/* Floating gradient blobs */}
      <motion.div
        className="blob blob-1"
        style={{ y: y1 }}
        animate={{
          x: [0, 30, -20, 0],
          y: [0, -30, 20, 0],
          scale: [1, 1.1, 0.95, 1],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="blob blob-2"
        style={{ y: y2 }}
        animate={{
          x: [0, -40, 20, 0],
          y: [0, 25, -15, 0],
          scale: [1, 0.9, 1.05, 1],
        }}
        transition={{ duration: 15, repeat: Infinity, ease: "easeInOut", delay: 2 }}
      />
      <motion.div
        className="blob blob-3"
        style={{ y: y3 }}
        animate={{
          x: [0, 20, -30, 0],
          y: [0, -20, 10, 0],
          scale: [1, 1.05, 0.9, 1],
        }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut", delay: 4 }}
      />
      <motion.div
        className="blob blob-4"
        animate={{
          x: [0, -15, 25, 0],
          y: [0, 20, -10, 0],
          scale: [1, 1.08, 0.92, 1],
        }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut", delay: 1 }}
      />

      {/* Grid overlay */}
      <div className="bg-grid" />

      {/* Noise texture */}
      <div className="bg-noise" />
    </div>
  );
};

export default Background;
